import React from "react";
import { Link } from "gatsby";
import { Container, Row, Col } from "react-bootstrap";
import { useStaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"

const Content = () => {
  const data = useStaticQuery(graphql`
    query {
      heroImage: file(relativePath: { eq: "marketing/inbound-page.png" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid_withWebp
          }
        }
      }
    }
  `)

  return (
    <>
      {/* <!-- Content Area --> */}
      <div className="content-section bg-default-6 pt-13 pt-lg-21 pb-13 pb-lg-21">
        <Container>
          <Row className="align-items-center justify-content-center">
            <Col
              sm="10"
              lg="6"
              className="offset-lg-1 order-lg-2 mb-9 mb-lg-0"
            >
              <div
                className="content-img rounded-10"
                style={{border: '8px solid #161C2D'}}
              >
                <Img
                  className="main-img w-100"
                  alt="Image 4"
                  fluid={data.heroImage.childImageSharp.fluid}
                />
              </div>
            </Col>
            <Col sm="10" lg="5" className="order-lg-1">
              <div className="content-text">
                <h2 className="gr-text-4 mb-7">
                  Not Just for the Home Page
                </h2>
                <p className="gr-text-8 mb-0">
                  Instant Demos aren’t just for optimizing the “Request a Demo” call to action. Embed them into email campaigns, product updates, release notes, social ads, and blog posts to generate and engage more qualified leads.
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Content;
